<template>
    <div class="ai-chat-wrapper" v-show="isOpen">
        <div class="aiChat" ref="aiChatPanel" :class="{ minimized: isMinimized }" :style="chatPanelStyle">
            <div class="chat-container" v-show="!isMinimized">
                <!-- 头部（非全屏时可拖拽移动窗口） -->
                <div class="chat-header" @mousedown="startDrag">
                    <div class="header-left">
                        <h2>飞凡智问-OCR{{ name }}</h2>
                    </div>
                    <div class="header-right">
                        <button style="margin-left: 5px;" type="button" icon="el-icon-minus" @mousedown.stop @click="showChat" class="minimize-button">
                            <i class="el-icon-minus"></i>
                        </button>
                        <button style="margin-left: 5px;" type="button" @mousedown.stop @click="toggleChat" class="minimize-button">X</button>
                    </div>
                </div>

                <!-- 文件上传区域 -->
                <div class="upload-area">
                    <div v-if="name=='商品'" class="good-type-tabs">
                        <span
                            class="good-type-tab"
                            :class="{ active: goodType === 0 }"
                            @click="goodType = 0"
                        >药品证照</span>
                        <span
                            class="good-type-tab"
                            :class="{ active: goodType === 1 }"
                            @click="goodType = 1"
                        >器械证照</span>
                        <span
                            class="good-type-tab"
                            :class="{ active: goodType === 2 }"
                            @click="goodType = 2"
                        >其他商品证照</span>
                    </div>
                    <div class="upload-toolbar">
                        <input style="display: none;" type="file" id="OCR识别" accept="image/*" multiple name="OCR识别" @change="(e) => { fileOCR(e.target.files, e.target.files.length, 0, e) }" />
                        <label for="OCR识别" class="btn btn-upload">
                            <i class="el-icon-upload"></i>
                            <span>上传图片</span>
                        </label>
                        <button type="button" class="btn btn-upload" @click="showUploadDialog()">
                            <i class="el-icon-upload"></i>
                            <span>拖拽上传</span>
                        </button>
                        <button type="button" class="btn btn-upload" @click="openFile1(0)">
                            <i class="el-icon-camera"></i>
                            <span>高拍仪</span>
                        </button>
                        <button v-if="printScanShow" type="button" class="btn btn-upload" @click="openFile1(1)">
                            <i class="el-icon-scanning"></i>
                            <span>扫描仪</span>
                        </button>
                    </div>
                    <ul class="image">
                        <li v-for="(item, index) in uploadVoList" :key="index">
                            <i class="el-icon-error del" @click="delRemove(index)"></i>
                            <cusImage class="image" :src="item.url" :preview-src-list="getUrl()"></cusImage>
                        </li>
                    </ul>
                    <p class="upload-tip">支持多张图片同时上传 · 共 {{ uploadVoList.length }} 张</p>
                    <div class="upload-actions">
                        <button type="button" class="btn btn-success" :class="{ disabled: uploadVoList.length === 0 || isUploading }" :disabled="uploadVoList.length === 0 || isUploading" @click="analysisOCR">
                            <i v-if="isUploading" class="el-icon-loading"></i>
                            <i v-else class="el-icon-search"></i>
                            <span>{{ isUploading ? '识别中...' : '开始识别' }}</span>
                        </button>
                        <button type="button" class="btn btn-default" :class="{ disabled: uploadVoList.length === 0 }" :disabled="uploadVoList.length === 0" @click="clearData">
                            <i class="el-icon-delete"></i>
                            <span>清空</span>
                        </button>
                    </div>
                </div>

                <!-- 上传进度提示 -->
                <div v-if="isUploading" class="upload-progress">
                    <span class="iconfont icon el-icon-loading"></span>
                    <span>正在上传并识别中...</span>
                </div>

                <!-- 识别结果展示区域 -->
                <div v-if="ocrResults.length > 0" class="results-area">
                    <div class="results-header">
                        <h3>识别结果</h3>
                        <el-button size="mini" type="primary" @click="emitResults">使用识别结果</el-button>
                    </div>
                    <div class="results-list">
                        <div v-for="(result, index) in ocrResults" :key="index" class="result-item">
                            <div class="result-header">
                                <span class="result-index">{{ index + 1 }}</span>
                                <span class="result-name">{{ result.name || '未命名' }}</span>
                            </div>
                            <div class="result-content">
                                <pre>{{ formatResult(result.text) }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 缩小后的悬浮小按钮（可拖拽） -->
            <div v-show="isMinimized" class="minimized-bar" @mousedown="startDrag($event, true)" @click="onMinimizedClick">
                <span class="minimized-title">飞凡智问-OCR{{ name }}</span>
                <i class="el-icon-full-screen minimized-expand"></i>
            </div>
        </div>
        <!-- 高拍仪 -->
        <FileNewAction ref="FileNewAction" v-if="showFile" :showFile="showFile" :scanFlag="true" @isshowFile="IsshowFile" @NewelectFileIds="changeFileIds"></FileNewAction>
        <!-- 扫描仪 -->
        <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPlugin" :scanFlag="true" @submit="scanOnSubmit"></scannerPlugin>
        </el-dialog>
        <DragUpload ref="dragUpload" title="文件上传" :multiple="true" :scanFlag="true" :limit="10" @confirm="onUploadConfirm" />
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'OCR',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        // 证照名称，用于AI识别时指定类型
        name: {
            type: String,
            default: "商品"
        },
    },
    watch: {
        visible(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.isOpen = newVal;
                if (this.isOpen) {
                    this.printScanShow = window.global_config.printScanShow ? true : false
                    this.getDictionaries()
                }
            }
        },
        isMinimized() {
            this.$nextTick(() => { this.ensureInViewport(); });
        },
        isOpen(val) {
            if (val) this.$nextTick(() => { this.ensureInViewport(); });
        },
    },
    data() {
        return {
            goodType:0,//商品类型：0.商品 1.器械 2.其他
            isOpen: false,
            isMinimized: false,
            zzList: [],
            /** 小窗口位置：null 表示使用默认右下角锚点 */
            panelPos: null,
            dragging: false,
            dragStart: { x: 0, y: 0 },
            panelStart: { left: 0, top: 0 },
            _dragMoved: false,
            _skipNextClick: false,

            // OCR相关数据
            aiResultData: "",
            fileList: [],
            uploadList: [],
            uploadVoList: [],
            ocrResults: [],
            isUploading: false,
            printScanShow: false,
            scanShow: false,
            showFile: false,
        }
    },
    computed: {
        chatPanelStyle() {
            if (this.panelPos) {
                return {
                    left: `${this.panelPos.left}px`,
                    top: `${this.panelPos.top}px`,
                    right: 'auto',
                    bottom: 'auto'
                };
            }
            return {
                right: '30px',
                bottom: '20px',
                left: 'auto',
                top: 'auto'
            };
        }
    },
    beforeDestroy() {
        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
        document.body.style.userSelect = '';
    },
    methods: {
        getUrl() {
            return this.uploadVoList.map(val => val.url)
        },
        showUploadDialog() {
            this.$refs.dragUpload.open();
        },
        onUploadConfirm(val) {
            this.fileOCR(val, val.length, 0, false)
        },
        //  打开文件上传组件
        openFile1(val) {
            if (val == 1) {
                this.scanShow = true
            } else {
                this.showFile = true
            }
        },
        IsshowFile(value) {
            this.showFile = value
            console.log(this.showFile)
        },
        changeFileIds(val) {
            this.fileOCR(val, val.length, 0, false)
            this.showFile = false
        },
        // 扫描仪上传
        scanOnSubmit(val) {
            this.fileOCR(val, val.length, 0, false)
            this.scanShow = false
        },
        // 删除图片
        delRemove(index) {
            var arr = this.uploadVoList.splice(index, 1)
            this.uploadList = this.uploadList.filter(item => item.id != arr[0].upload_file_id)
            this.fileList = this.fileList.filter(item => item.upload_file_id != arr[0].upload_file_id)
        },
        async getDictionaries() {
            var arr = []
            if (this.name == '商品') {
                if (this.goodType==1) {
                    arr = [70]
                }else if (this.goodType==2) {
                    arr = [71]
                }else{
                    arr = [30]
                }
            } else if (this.name == '供应商') {
                arr = [41]
            } else if (this.name == '客户') {
                arr = [55]
            }
            let responseData = await this.$http.getPartDictionariesData({
                ids: arr,
            });
            if (responseData.status == 200) {
                if (this.name == '商品') {
                    this.zzList = responseData.result.spzzlx;
                } else if (this.name == '供应商') {
                    this.zzList = responseData.result.DWZZLX;
                } else if (this.name == '客户') {
                    this.zzList = responseData.result.khzzlx;
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        startDrag(e, isFromMinimized) {
            if (!this.isOpen) return;
            if (e.button !== 0) return;
            if (!isFromMinimized && e.target.closest('.header-right')) return;

            const panel = this.$refs.aiChatPanel;
            if (!panel) return;

            const rect = panel.getBoundingClientRect();
            if (!this.panelPos) {
                this.panelPos = { left: rect.left, top: rect.top };
            }
            this.dragging = true;
            this._dragMoved = false;
            this.dragStart = { x: e.clientX, y: e.clientY };
            this.panelStart = { left: this.panelPos.left, top: this.panelPos.top };
            document.addEventListener('mousemove', this.onDragMove);
            document.addEventListener('mouseup', this.onDragEnd);
            document.body.style.userSelect = 'none';
            e.preventDefault();
        },
        onDragMove(e) {
            if (!this.dragging) return;
            const panel = this.$refs.aiChatPanel;
            if (!panel) return;

            const dx = e.clientX - this.dragStart.x;
            const dy = e.clientY - this.dragStart.y;
            if (!this._dragMoved && Math.abs(dx) + Math.abs(dy) > 3) {
                this._dragMoved = true;
            }
            let left = this.panelStart.left + dx;
            let top = this.panelStart.top + dy;

            const pw = panel.offsetWidth;
            const ph = panel.offsetHeight;
            const maxLeft = Math.max(0, window.innerWidth - pw);
            const maxTop = Math.max(0, window.innerHeight - ph);

            left = Math.min(Math.max(0, left), maxLeft);
            top = Math.min(Math.max(0, top), maxTop);

            this.panelPos = { left, top };
        },
        onDragEnd() {
            if (!this.dragging) return;
            if (this._dragMoved && this.isMinimized) {
                this._skipNextClick = true;
                setTimeout(() => { this._skipNextClick = false; }, 0);
            }
            this.dragging = false;
            document.removeEventListener('mousemove', this.onDragMove);
            document.removeEventListener('mouseup', this.onDragEnd);
            document.body.style.userSelect = '';
        },
        onMinimizedClick() {
            if (this._skipNextClick) { this._skipNextClick = false; return; }
            this.showChat();
        },
        ensureInViewport() {
            if (!this.panelPos) return;
            const panel = this.$refs.aiChatPanel;
            if (!panel) return;
            const pw = panel.offsetWidth;
            const ph = panel.offsetHeight;
            if (!pw || !ph) return;
            let left = this.panelPos.left;
            let top = this.panelPos.top;
            const maxLeft = Math.max(0, window.innerWidth - pw);
            const maxTop = Math.max(0, window.innerHeight - ph);
            left = Math.min(Math.max(0, left), maxLeft);
            top = Math.min(Math.max(0, top), maxTop);
            if (left !== this.panelPos.left || top !== this.panelPos.top) {
                this.panelPos = { left, top };
            }
        },
        // 切换聊天框显示/隐藏
        toggleChat() {
            this.isOpen = !this.isOpen;
            this.isMinimized = false;
            // OCR相关数据
            this.aiResultData = "";
            this.fileList = [];
            this.uploadList = [];
            this.uploadVoList = [];
            this.ocrResults = [];
            this.isUploading = false;
            this.$emit('closeAIChat');
        },

        // 缩小 / 恢复 弹框
        showChat() {
            this.isMinimized = !this.isMinimized;
        },

        // 处理文件上传
        async fileOCR(files, length, index, e) {
            if (length - 1 >= index) {
                const file = files[index];
                const formData = new FormData();
                formData.append('file', file);
                formData.append('user', "abc-123");

                try {
                    // 上传文件到AI服务器
                    const res = await axios.post(
                        `${window.global_config.AI_CHAT_URL}/v1/files/upload`,
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "Authorization": `Bearer ${window.global_config.AI_API.OCR_API_KEY}`,
                            },
                        }
                    );

                    console.log('上传成功:', res);

                    // 记录文件信息
                    this.fileList.push({
                        "transfer_method": "local_file",
                        "upload_file_id": res.data.id,
                        "type": "image"
                    });

                    this.uploadList.push({
                        "file": file,
                        id: res.data.id,
                    });

                    // 递归上传下一个文件
                    await this.fileOCR(files, length, index + 1, e);
                } catch (error) {
                    if (e) {
                        e.target.value = "";
                    }
                    console.error('上传失败:', error);
                    this.$message.error('文件上传失败');
                }
            } else {
                // 所有文件上传完成
                if (e) {
                    e.target.value = "";
                }
                if (this.fileList.length > 0) {
                    await this.uploadToServer();
                }
            }
        },

        // 上传文件到业务服务器
        async uploadToServer(index = 0) {
            console.log('开始上传到业务服务器', this.uploadList);

            if (this.uploadList.length - 1 >= index) {
                try {
                    const params = {
                        file: this.uploadList[index].file,
                    };

                    const response = await this.$http.uploadFile(params, true);
                    console.log('业务服务器上传响应:', response);

                    if (response.status == 200) {
                        this.uploadVoList.push({
                            fileUrl: response.result[0].fileUrl,
                            url: window.global_config.BASE_IMG_URL + "/" + response.result[0].fileUrl,
                            fileName: response.result[0].fileName,
                            fileId: response.result[0].fileId,
                            fileType: "",
                            upload_file_id: this.uploadList[index].id,
                        });

                        // 递归上传下一个文件
                        await this.uploadToServer(index + 1);
                    } else {
                        this.$message.error(response.message);
                    }
                } catch (error) {
                    console.error('上传到业务服务器失败:', error);
                    this.$message.error('上传失败');
                }
            } else {
                this.uploadList = []
                // 所有文件上传完成，开始OCR识别
                // await this.analysisOCR();
            }
        },

        // 执行OCR识别
        async analysisOCR() {
            this.isError = false;
            if (this.uploadVoList.length > 10) {
                this.$message.error('最多只能上传10张图片');
                return;
            }


            this.isUploading = true;
            const params = {
                response_mode: "streaming",
                "inputs": {
                    "file": this.fileList,
                    "name": this.name,
                    "str": JSON.stringify(this.zzList)
                },
                user: "abc-123"
            };
            try {
                const response = await fetch(`${window.global_config.AI_CHAT_URL}/v1/workflows/run`, {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${window.global_config.AI_API.OCR_API_KEY}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(params)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let buffer = '';

                while (true) {
                    const { done, value } = await reader.read();
                    if (done) {
                        this.isUploading = false;
                        if (this.isError) {
                            if (this.aiResultData.indexOf('[tongyi] Incorrect model credentials provided, please check and try again') !== -1) {
                                this.$message.error('模型鉴权失败：API密钥配置错误，请联系管理员')
                            } else {
                                this.$message.error(this.aiResultData)
                            }
                            return;
                        }
                        // 处理OCR结果数据，将字符串转换为数组
                        const processedData = this.processOCRResults(this.aiResultData);
                        // 关联上传的文件信息
                        processedData.forEach(data => {
                            var arr = this.uploadVoList.filter(val => val.upload_file_id == data.id);
                            if (arr.length > 0) {
                                data.uploadVoList = arr;
                            }
                        });

                        console.log('处理后的数组数据:', processedData);
                        this.ocrResults = processedData;

                        break;
                    }

                    buffer += decoder.decode(value, { stream: true });
                    const lines = buffer.split('\n');
                    buffer = lines.pop();

                    lines.forEach(line => {
                        if (line.startsWith('data:')) {
                            const data = line.substring(5).trim();
                            if (data) {
                                try {
                                    const parsedData = JSON.parse(data);
                                    if (parsedData.event == 'text_chunk'&&!this.isError) {
                                        this.aiResultData = parsedData.data.text;
                                    } else {
                                        if (parsedData.data.error != null) {
                                            this.isError = true;
                                            this.aiResultData = parsedData.data.error;
                                        }
                                    }
                                } catch (e) {
                                    console.error('解析数据失败:', e);
                                }
                            }
                        }
                    });
                }
            } catch (error) {
                this.isUploading = false;
                console.error('OCR识别失败:', error);
                this.$message.error('OCR识别失败，请重试');
            }
        },

        // 处理OCR识别结果,将字符串格式转换为数组
        processOCRResults(resultString) {
            if (!resultString || typeof resultString !== 'string') {
                return [];
            }

            try {
                // 如果结果是JSON数组格式的字符串,直接解析
                if (resultString.trim().startsWith('[')) {
                    return JSON.parse(resultString);
                }

                // 如果是多行字典格式(每行以'- {'开头),按行分割并解析
                const lines = resultString.split('\n').filter(line => line.trim());
                const resultArray = [];

                for (let line of lines) {
                    // 去除前缀 '- ' 或其他标记
                    let cleanLine = line.replace(/^[-*]\s*/, '').trim();

                    // 尝试解析为JSON对象
                    if (cleanLine.startsWith('{') && cleanLine.endsWith('}')) {
                        try {
                            // Python字典转JSON: 将单引号替换为双引号
                            let jsonStr = cleanLine
                                .replace(/'/g, '"')  // 单引号转双引号
                                .replace(/None/g, 'null')  // Python的None转null
                                .replace(/True/g, 'true')  // Python的True转true
                                .replace(/False/g, 'false');  // Python的False转false

                            const obj = JSON.parse(jsonStr);
                            resultArray.push(obj);
                        } catch (e) {
                            console.warn('无法解析行数据:', line, e);
                            // 尝试更复杂的转换处理
                            try {
                                const obj = this.pythonDictToJson(cleanLine);
                                if (obj) {
                                    resultArray.push(obj);
                                }
                            } catch (e2) {
                                console.error('二次解析也失败:', line, e2);
                            }
                        }
                    }
                }

                return resultArray;
            } catch (error) {
                console.error('处理OCR结果失败:', error);
                return [];
            }
        },

        // 更强大的Python字典转JSON方法
        pythonDictToJson(pyStr) {
            try {
                // 处理嵌套的单引号和特殊字符
                let result = pyStr
                    .replace(/None/g, 'null')
                    .replace(/True/g, 'true')
                    .replace(/False/g, 'false');

                // 使用正则表达式更安全地替换引号
                result = result.replace(/:\s*'([^']*)'/g, ': "$1"');  // 值部分的单引号
                result = result.replace(/'([^']*)'\s*:/g, '"$1":');    // 键部分的单引号

                return JSON.parse(result);
            } catch (e) {
                console.error('Python字典转换失败:', e);
                return null;
            }
        },

        // 格式化结果显示
        formatResult(result) {
            if (!result) return '';
            // 移除uploadVoList等内部字段，只显示业务数据
            const displayData = result;
            return JSON.stringify(displayData, null, 2);
        },

        // 发送识别结果给父组件
        emitResults() {
            if (this.ocrResults.length === 0) {
                this.$message.warning('暂无识别结果');
                return;
            }
            // 触发路由跳转
            if (this.name == '商品') {
                this.$emit('tabChange', { path: "/firstGoodsList", query: {ocrResults:this.ocrResults,goodType:this.goodType} })
            } else if (this.name == '客户') {
                this.$emit('tabChange', { path: "/firstCustomerList", query: this.ocrResults })
            } else if (this.name == '供应商') {
                this.$emit('tabChange', { path: "/firstSupplierList", query: this.ocrResults })
            }
            this.toggleChat()
        },

        // 清空数据
        clearData() {
            this.fileList = [];
            this.uploadList = [];
            this.uploadVoList = [];
            this.ocrResults = [];
            this.aiResultData = "";
            this.isUploading = false;
        }
    },
}
</script>

<style scoped>
ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

/* 1. 包装器：固定定位在右下角 */
.ai-chat-wrapper {
    position: fixed;
    right: 30px;
    bottom: 20px;
    z-index: 999;
}

/* 2. 聊天框主体（小窗口：fixed，便于拖拽定位） */
.aiChat {
    position: fixed;
    z-index: 999;
    width: 500px;
    height: 80vh;
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.chat-container {
    width: 100%;
    height: 100%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    color: #333333;
}

/* 3. 头部样式 */
.chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
    cursor: move;
}

.header-right {
    display: flex;
    align-items: center;
    width: auto;
}

.header-left h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
}

.minimize-button {
    background: none;
    border: none;
    color: #999999;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.minimize-button:hover {
    background-color: #f0f0f0;
    color: #666666;
}

/* 4. 上传区域样式 */
.upload-area {
    padding: 15px 20px;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
}

.good-type-tabs {
    display: inline-flex;
    align-items: center;
    margin-bottom: 12px;
    padding: 3px;
    background: #f5f7fa;
    border-radius: 6px;
    gap: 2px;
}

.good-type-tab {
    padding: 6px 14px;
    font-size: 13px;
    line-height: 1.2;
    color: #606266;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.good-type-tab:hover {
    color: #409eff;
}

.good-type-tab.active {
    background: #ffffff;
    color: #409eff;
    font-weight: 500;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.upload-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

/* 通用自定义按钮基础样式 */
.btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    line-height: 1;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    background-color: #ffffff;
    color: #606266;
}

.btn i {
    font-size: 14px;
    line-height: 1;
}

.btn:hover:not(.disabled):not([disabled]) {
    opacity: 0.9;
}

.btn:active:not(.disabled):not([disabled]) {
    transform: translateY(1px);
}

.btn.disabled,
.btn[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
}

/* 上传按钮（虚线边框） */
.btn-upload {
    background-color: #f0f7ff;
    border: 1px dashed #4a90e2;
    color: #4a90e2;
}

.btn-upload:hover:not(.disabled):not([disabled]) {
    background-color: #e6f2ff;
    border-color: #3a80d2;
}

/* 主按钮：蓝色 */
.btn-primary {
    background-color: #409eff;
    border-color: #409eff;
    color: #ffffff;
}

.btn-primary:hover:not(.disabled):not([disabled]) {
    background-color: #66b1ff;
    border-color: #66b1ff;
}

/* 成功按钮：绿色 */
.btn-success {
    background-color: #67c23a;
    border-color: #67c23a;
    color: #ffffff;
}

.btn-success:hover:not(.disabled):not([disabled]) {
    background-color: #85ce61;
    border-color: #85ce61;
}

/* 默认按钮：灰色 */
.btn-default {
    background-color: #ffffff;
    border-color: #dcdfe6;
    color: #606266;
}

.btn-default:hover:not(.disabled):not([disabled]) {
    background-color: #f5f7fa;
    border-color: #c0c4cc;
    color: #409eff;
}

.image {
    margin-top: 12px;
    min-height: 0;
}
.image li {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    width: 62px;
    height: 62px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    vertical-align: top;
}
.image li .image {
    margin-top: 0;
}
.del {
    display: none;
    position: absolute;
    top: -2px;
    right: -2px;
    font-size: 16px;
    z-index: 99;
    cursor: pointer;
    color: #f56c6c;
    background-color: #ffffff;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.del:hover {
    color: #f56c6c;
}

.image li:hover .del {
    display: inline-block;
}
.upload-tip {
    margin: 8px 0 0;
    font-size: 12px;
    color: #999999;
    text-align: left;
}

.upload-actions {
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed #ebeef5;
}

/* 5. 上传进度提示 */
.upload-progress {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background-color: #fff7e6;
    border-bottom: 1px solid #e0e0e0;
    color: #fa8c16;
    font-size: 14px;
}

.upload-progress .icon {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* 6. 识别结果区域 */
.results-area {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    background-color: #fafafa;
}

.results-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #e0e0e0;
}

.results-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
}

.results-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.result-item {
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.result-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.result-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 15px;
    background-color: #f0f7ff;
    border-bottom: 1px solid #e0e0e0;
}

.result-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #4a90e2;
    color: #ffffff;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
}

.result-name {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
}

.result-content {
    padding: 15px;
    max-height: 250px;
    overflow-y: auto;
}

.result-content pre {
    margin: 0;
    font-family: "Courier New", monospace;
    font-size: 13px;
    line-height: 1.6;
    color: #333333;
    white-space: pre-wrap;
    word-wrap: break-word;
}

/* 滚动条样式 */
.results-area::-webkit-scrollbar,
.result-content::-webkit-scrollbar {
    width: 6px;
}

.results-area::-webkit-scrollbar-track,
.result-content::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 3px;
}

.results-area::-webkit-scrollbar-thumb,
.result-content::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 3px;
}

.results-area::-webkit-scrollbar-thumb:hover,
.result-content::-webkit-scrollbar-thumb:hover {
    background: #999999;
}

/* 缩小后的样式 */
.aiChat.minimized {
    width: 220px;
    height: 44px;
    overflow: hidden;
}

.minimized-bar {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    user-select: none;
}

.minimized-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.minimized-expand {
    font-size: 18px;
    color: #4a90e2;
    margin-left: 8px;
    flex-shrink: 0;
}

.minimized-bar:hover {
    background-color: #f0f7ff;
}
</style>